module.exports = __webpack_public_path__ + "static/media/photo-03-cgv.8bb06748.png";